<div *ngIf="lx('ContactUrl')" class="topbar-item px-5">
    <a [class]="textCssClass" [href]="l('ContactUrl') | safe: 'url'" target="_blank">{{l('ContactHeaderText')}}</a>
</div>
